import React from 'react'
import Card from '../../components/Card'

const whatsappUrl = 'https://api.whatsapp.com/send/?phone=5511000000000&text=Ol%C3%A1%2C+quero+saber+mais+sobre+o+ProntuárioMédico.&type=phone_number&app_absent=0'
const email = 'suporte@positronictech.com.br'

export default function () {
	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:mx-32 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-4">Contatos</h1>

				<p>E-mail: <a href={`mailto:${email}`}>{email}</a></p>
				<p>WhatsApp: <a href={whatsappUrl}>(11) 00000-0000</a></p>
			</Card>
		</div>
	)
}
